var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('iframe',{staticClass:"iframe",attrs:{"src":`${_vm.$env.VUE_APP_VUE_3_CLIENT_URL}/company/${_vm.$route.params.company_id}/data/integrations`,"allow":"*"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }